/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Field_Assistant_Prompt_Q2_C3Inputs */



/**
* | output |
* | --- |
* | "Assume the sensible thing and flag it" |
*
* @param {Uno_Field_Assistant_Prompt_Q2_C3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_field_assistant_prompt_q2_c3 = /** @type {((inputs?: Uno_Field_Assistant_Prompt_Q2_C3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Field_Assistant_Prompt_Q2_C3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sinnvoll annehmen und darauf hinweisen")
	return /** @type {LocalizedString} */ ("Assume the sensible thing and flag it")
});